import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Dialog } from '@headlessui/react';
import { CloseIcon } from '@root/styles/icons';
import { Text } from '@common/components/Typography';

const inset = css`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const SPACING = '1.875rem';

export const StyledDialog = styled(Dialog)`
  position: fixed;
  ${inset}
  z-index: 9999;
` as typeof Dialog;

export const Backdrop = styled.div`
  position: fixed;
  ${inset}
  background-color: rgba(0, 0, 0, 0.3);
`;

export const Content = styled.div`
  position: fixed;
  ${inset}
  padding: 60px 15px 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  ${media.md`
    padding-top: 0;
    align-items: center;
  `}
`;

export const Description = styled(Text)`
  white-space: pre-line;
`;

export const Panel = styled(Dialog.Panel)`
  margin: 0 auto;
  width: 100%;
  max-width: 32rem;
  background-color: white;
  border-radius: 0.25rem;
  padding: ${SPACING};
  font-family: ${({ theme }) => theme.bodyFont};
`;

export const StyledClose = styled(CloseIcon)`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  cursor: pointer;
`;

export const Toolbar = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1.25rem 0;
  margin-top: -${SPACING};
  margin-left: -${SPACING};
  margin-right: -${SPACING};
  margin-bottom: ${SPACING};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;

  ${media.md`
    flex-direction: row;
  `}
`;
